// SortType contains the possible sort methods for Med List
export const SortTypeMap = {
    ALPHABETICAL: 'ALPHABETICAL',
    LAST_DISPENSED_DATE: 'LAST_DISPENSED_DATE',
    PRESCRIBED_DATE: 'PRESCRIBED_DATE',
};
// PrescriptionStatus represents the status of a prescription that is a part of a medication. Each prescription within a
// medication can be in a different status.
export const PrescriptionStatusMap = {
    UPCOMING_ORDER: 'UPCOMING_ORDER',
    PROCESSING: 'PROCESSING',
    ELIGIBLE_FOR_CART: 'ELIGIBLE_FOR_CART',
    REFILLS_REQUESTED: 'REFILLS_REQUESTED',
    INACTIVE: 'INACTIVE',
};
// MedDetailsCTAType represents the possible CTA types in the Prescription card on the Med Details page.
// Any addition or removal to these CTA types require a bump in the endpoint version number.
export const MedDetailsPrescriptionCTATypeMap = {
    NONE: 'NONE',
    CHECK_STATUS: 'CHECK_STATUS',
    DISCONTINUE: 'DISCONTINUE',
    ADD_TO_CART: 'ADD_TO_CART',
    REMOVE_FROM_CART: 'REMOVE_FROM_CART',
    // VIEW_ORDER represents both pickup and deliveries - the copy will differ depending on delivery method
    VIEW_ORDER: 'VIEW_ORDER',
    ENROLL_IN_AUTO_REFILL: 'ENROLL_IN_AUTO_REFILL',
    TURN_OFF_AUTO_REFILL: 'TURN_OFF_AUTO_REFILL',
    REQUEST_MORE_REFILLS: 'REQUEST_MORE_REFILLS',
    VIEW_REFILL_REQUEST: 'VIEW_REFILL_REQUEST',
    CANCEL_REFILL_REQUEST: 'CANCEL_REFILL_REQUEST',
    PROGYNY_ORDER_EARLY: 'PROGYNY_ORDER_EARLY',
};
// Copy/pasted from our design system tag types.
// https://github.com/scriptdash/clients/blob/d52b71650fe93e958d7999deff4cd2e045aaf775/libs/design-system/src/components/tags/src/tagUtils.ts#L3-L3
export const StatusColorVariantMap = {
    RECOMMENDED: 'recommended',
    NEUTRAL: 'neutral',
    WARNING: 'warning',
    ERROR: 'error',
    INACTIVE: 'inactive',
};
//# sourceMappingURL=types.js.map